import React from "react"
import { Skeleton } from "@material-ui/lab"
import {
	Grid,
	makeStyles
} from "@material-ui/core"

import { Portlet, Divider } from "@/components"

const useStyles = makeStyles({
	container: {
		height: 70
	}
})

const Integration = () => {
	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			spacing={2}
		>
			<Skeleton variant="rect" width={160} height={50} />

			<Divider size={3} orientation="horizontal" />

			<Skeleton variant="rect" width={200} height={24} />

			<Divider size={3} orientation="horizontal" />

			<Portlet
				elevation={1}
			>
				<Grid
					container
					alignItems="center"
					justify="space-between"
					className={classes.container}
				>
					<Skeleton variant="rect" width={300} height={50} />

					<Skeleton variant="circle" width={40} height={40} />
				</Grid>
			</Portlet>

			<Divider size={2} orientation="horizontal" />

			<Portlet
				elevation={1}
			>
				<Grid
					container
					alignItems="center"
					justify="space-between"
					className={classes.container}
				>
					<Skeleton variant="rect" width={300} height={50} />

					<Skeleton variant="circle" width={40} height={40} />
				</Grid>
			</Portlet>
		</Grid>
	)
}

export default Integration
